import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Country } from "types/country";

export const useCountries = () => {
  const [countries, setCountries] = React.useState<Country[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      try {
        setFetching(true);
        const response = await axios.get(
          `${API_BASE_URL}${API_URLS.Countries}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        setCountries(response.data.data);
      } catch (e) {
        console.error(e);
      } finally {
        setFetching(false);
      }
    })();
  }, []);
  return { countries, fetching };
};
